import { AxiosInstance } from "axios"

import { DeviceReportResponse } from "./supplierHomeTypes"

export enum SupplierHomeQuery {
    DEVICE_REPORT = "device-report-for-supplier",
}

type DeviceReportParams = Readonly<{
    supplierId: number
}>

export async function fetchDeviceReport(
    { supplierId }: DeviceReportParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DeviceReportResponse> {
    const url = `/suppliers/${supplierId}/dashboard/deviceReport`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}
